import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/crm/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Customers from "@/pages/Customers";
import Quotations from "@/pages/Quotations";
import QuotationPrint from "@/pages/QuotationPrint";
import QuotationInvoice from "@/pages/QuotationInvoice";
import TaxInvoices from "@/pages/TaxInvoices";
import TaxInvoicePrint from "@/pages/TaxInvoicePrint";
import WorkCompletion from "@/pages/WorkCompletion";
import WorkCompletionPrint from "@/pages/WorkCompletionPrint";
import Payments from "@/pages/Payments";
import MaterialRequisition from "@/pages/MaterialRequisition";
import MaterialRequisitionPrint from "@/pages/MaterialRequisitionPrint";
import Hisaab from "@/pages/Hisaab";
import HisaabPrint from "@/pages/HisaabPrint";
import Projects from "@/pages/Projects";
import Services from "@/pages/Services";
import Complaints from "@/pages/Complaints";
import ComplaintPrint from "@/pages/ComplaintPrint";
import ComplaintRegister from "@/pages/ComplaintRegister";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Integrations from "@/pages/Integrations";

const Guard = ({ roles, perm, children }) => (
  <ProtectedRoute roles={roles} perm={perm}><Layout>{children}</Layout></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/complaint-register" element={<ComplaintRegister />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Admin-only */}
            <Route path="/dashboard" element={<Guard roles={["admin"]} perm="dashboard"><Dashboard /></Guard>} />
            <Route path="/tax-invoices" element={<Guard roles={["admin"]} perm="tax_invoices"><TaxInvoices /></Guard>} />
            <Route path="/tax-invoices/:id/print" element={<ProtectedRoute roles={["admin"]} perm="tax_invoices"><TaxInvoicePrint /></ProtectedRoute>} />
            <Route path="/work-completion" element={<Guard roles={["admin","sales"]} perm="wcr"><WorkCompletion /></Guard>} />
            <Route path="/work-completion/:id/print" element={<ProtectedRoute roles={["admin","sales"]} perm="wcr"><WorkCompletionPrint /></ProtectedRoute>} />
            <Route path="/payments" element={<Guard roles={["admin","sales"]} perm="payments"><Payments /></Guard>} />
            <Route path="/material-requisition" element={<Guard roles={["admin","sales"]} perm="mrn"><MaterialRequisition /></Guard>} />
            <Route path="/material-requisition/:id/print" element={<ProtectedRoute roles={["admin","sales"]} perm="mrn"><MaterialRequisitionPrint /></ProtectedRoute>} />
            <Route path="/hisaab" element={<Guard roles={["admin","sales"]} perm="hisaab"><Hisaab /></Guard>} />
            <Route path="/hisaab/print" element={<ProtectedRoute roles={["admin","sales"]} perm="hisaab"><HisaabPrint /></ProtectedRoute>} />
            <Route path="/projects" element={<Guard roles={["admin"]} perm="projects"><Projects /></Guard>} />
            <Route path="/reports" element={<Guard roles={["admin"]} perm="reports"><Reports /></Guard>} />
            <Route path="/users" element={<Guard roles={["admin"]} perm="users"><Users /></Guard>} />
            <Route path="/settings" element={<Guard roles={["admin"]} perm="settings"><Settings /></Guard>} />
            <Route path="/integrations" element={<Guard roles={["admin"]} perm="integrations"><Integrations /></Guard>} />

            {/* Admin + Sales */}
            <Route path="/leads" element={<Guard roles={["admin","sales"]} perm="leads"><Leads /></Guard>} />
            <Route path="/customers" element={<Guard roles={["admin","sales"]} perm="customers"><Customers /></Guard>} />
            <Route path="/quotations" element={<Guard roles={["admin","sales"]} perm="quotations"><Quotations /></Guard>} />
            <Route path="/quotations/:id/print" element={<ProtectedRoute roles={["admin","sales"]} perm="quotations"><QuotationPrint /></ProtectedRoute>} />
            <Route path="/quotations/:id/invoice" element={<ProtectedRoute roles={["admin","sales"]} perm="quotations"><QuotationInvoice /></ProtectedRoute>} />

            {/* Admin + Technician */}
            <Route path="/services" element={<Guard roles={["admin","technician"]} perm="services"><Services /></Guard>} />
            <Route path="/complaints" element={<Guard roles={["admin","technician"]} perm="complaints"><Complaints /></Guard>} />
            <Route path="/complaints/:id/print" element={<ProtectedRoute roles={["admin","technician"]} perm="complaints"><ComplaintPrint /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
